import { api, helpers } from "../../../utils";
import moment from "moment";
const { stored } = api.net.config;
const cafe = {
    format: {
        date: "YYYY-MM-DD",
    },
    sms: {
        project: {
            notfound: "Xin lỗi, hệ thống không thể tìm thấy dự án này!",
        },
        session_timeout: api.sms.session_timeout,
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const hlog = helpers.html.log;

const loadList = async ({ rootState, commit }) => {
    let p = new Promise(async (resolve) => {
        const { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        const { SessionID } = headers;
        let filter = { SessionID };
        hlog.start("store.projects.list", "start");
        const storeName = stored.seo.prj.GetProjectList;
        const res_list = await api.net.data.seo.load.list({ storeName, filter });
        let isNotValid = !res_list || !res_list.isSuccess || !Array.isArray(res_list.data);
        if (isNotValid) return resolve({ error: res_list.error });
        let data = handleDataList({ data: res_list.data });
        hlog.end("store.member.list", "end", data);
        commit({ type: "loadData", data });
        resolve({ isSuccess: true });
    });

    return p;
};

const loadDetail = async ({ rootState, state, commit }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload || !payload.ProjectID) return resolve({ error: cafe.sms.invalid_inputs });
        const { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        const { SessionID } = headers;
        const { ProjectID } = payload;
        let filter = { SessionID, ProjectID };
        hlog.start("store.projects.detail", "start", filter);
        const storeName = stored.seo.prj.GetProjectDetail;
        const res_detail = await api.net.data.seo.load.multiList({ storeName, filter });
        let isNotValid = !res_detail || !res_detail.isSuccess || !Array.isArray(res_detail.data);
        if (isNotValid) return resolve({ error: res_detail.error });
        let item = res_detail.data[0][0];
        if (!item) return resolve({ error: cafe.sms.project.notfound });
        let prj = handleDataDetail({ item });
        hlog.end("store.projects.detail", "end", prj);
        let data = { detail: state.detail };
        data.detail[ProjectID] = prj;
        commit({ type: "loadData", data });
        resolve({ isSuccess: true, data: prj });
    });

    return p;
};

const add = ({ state, dispatch }, filter) => {
    const p = new Promise(async (resolve) => {
        /*********|config data|*********/
        if (!filter) return resolve({ error: cafe.sms.invalid_inputs });
        let text = "store.project.add";
        const { ProjectTitle, ProjectHost } = filter;
        let payload = {
            type: "seo.project.add",
            filter: { ProjectTitle, ProjectHost }
        };
        hlog.start(text, "start", payload.filter);
        const res_add = await api.node.origin.seo.project(payload);
        const isInValid = !res_add.is_success || res_add.error || !Array.isArray(res_add.data);
        if (isInValid) return resolve({ error: res_add.error });
        const isUnauthen = res_add.data.length <= 0;
        if (isUnauthen) return resolve({ error: cafe.sms.session_timeout });
        await dispatch("loadList");
        const { ProjectID } = res_add.data[0];
        let data = state.obj[ProjectID];
        if (!data) return resolve({ error: cafe.sms.permission_denied });
        hlog.end(text, "end", ProjectID);
        resolve({ isSuccess: true, data });
    });

    return p;
};

const handleDataList = ({ data }) => {
    let state = { list: [], obj: {} };
    if (!Array.isArray(data)) return state;
    let list = { projects: data };
    for (let item of list.projects) {
        let { ProjectID } = item;
        let prj = handleDataDetail({ item });
        state.obj[ProjectID] = prj;
    };
    for (let ProjectID of Object.keys(state.obj)) {
        let obj = state.obj[ProjectID];
        state.list.push(obj);
    };

    return state;
};

const handleDataDetail = ({ item }) => {
    let { ProjectID, ProjectTitle, ProjectHost } = item;
    let CreateDate = moment(item.CreateDate).format(cafe.format.date);
    let prj = { ProjectID, ProjectTitle, ProjectHost, CreateDate };
    return prj;
};

export default {
    loadList,
    loadDetail,
    add,
};



// WEBPACK FOOTER //
// src/store/views/projects/actions.js